import React from 'react';

const FileName = ({ name, showFullName, className = '' }) => {
    const maxLength = showFullName ? 120 : 40;
    const shouldTruncate = name.length > maxLength;
    const displayName = shouldTruncate ? `${name.slice(0, maxLength)}...` : name;

    return (
        <div
            className={`${showFullName
                    ? 'whitespace-normal break-words'
                    : 'whitespace-nowrap overflow-hidden text-ellipsis'
                } ${className}`}
            title={shouldTruncate ? name : undefined}
        >
            {displayName}
        </div>
    );
};

export default FileName;
